import React from "react";
import { Collapse, Table, Tag, Spin } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import NoDataAvailable from "./NoDataAvailable";
import "../style.css";

const { Panel } = Collapse;

const TestResults = ({ labAnalyticsDetails, isLoading }) => {
  const { testResults } = labAnalyticsDetails || {};
  const testResultData = testResults || {};
  
  // Get all available test result categories dynamically
  const getTestSections = () => {
    const sections = [];
    let keyCounter = 1;

    Object.entries(testResultData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        sections.push({
          key: keyCounter.toString(),
          label: `${key} (${value.length})`,
          data: value,
        });
        keyCounter++;
      }
    });

    return sections;
  };

  // Table columns
  const columns = [
    {
      title: "Parameter",
      dataIndex: "labxParameter",
      key: "labxParameter",
      width: "30%",
      render: (text) => (
        <span style={{ color: "#0a8080", fontWeight: "400" }}>{text}</span>
      ),
    },
    {
      title: "Result",
      dataIndex: "parameterValue",
      key: "parameterValue",
      width: "15%",
      render: (text) => <span style={{ color: "#262626" }}>{text ?? "-"}</span>,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      width: "15%",
      render: (text) => <span style={{ color: "#8C8C8C" }}>{text ?? "-"}</span>,
    },
    {
      title: "Threshold",
      dataIndex: "fssrLimit",
      key: "fssrLimit",
      width: "15%",
      render: (text) => <span style={{ color: "#262626" }}>{text ?? "-"}</span>,
    },
    {
      title: "Compliance",
      dataIndex: "compliance",
      key: "compliance",
      width: "25%",
      render: (text) => {
        return (
          <Tag
            color={getTagColor(text)}
            style={{
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            {text}
          </Tag>
        );
      },
    },
  ];

  const testSections = getTestSections();

  return (
    <div
      style={{
        padding: "20px 30px",
        border: "1px solid #E0E0E0",
        borderRadius: 8,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ flex: 1 }}>
        <p
          style={{
            fontWeight: "bold",
            fontSize: 16,
            paddingBottom: "5px",
            borderBottom: "1px solid #D9D9D9",
            marginBottom: "20px",
          }}
        >
          Test Results
        </p>

        {isLoading ? (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            flexDirection: "column"
          }}>
            <Spin />
            <p style={{
              marginTop: "16px",
              fontSize: "14px",
              color: "#8C8C8C"
            }}>Loading test results...</p>
          </div>
        ) : !testResults ? (
          <NoDataAvailable
            title="No Test Results Available"
            description="Test results will appear here once data is available"
            height="200px"
          />
        ) : (
          <Collapse
            //   defaultActiveKey={["1"]}
            expandIconPosition="right"
            expandIcon={({ isActive }) => (
              <CaretRightOutlined
                style={{ color: "#0a8080" }}
                rotate={isActive ? 90 : 0}
              />
            )}
            ghost
            style={{
              backgroundColor: "transparent",
            }}
          >
          {testSections.map((section) => (
            <Panel
              key={section.key}
              header={
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#0a8080",
                  }}
                >
                  {section.label}
                </span>
              }
              style={{
                marginBottom: "12px",
                backgroundColor: "#FAFAFA",
                //  backgroundColor: "#eff3f7",
                border: "1px solid #E8E8E8",
                borderRadius: "6px",
                color: "#0a8080",
              }}
            >
              <div style={{ backgroundColor: "#FAFAFA", border: "none" }}>
                <Table
                  rowKey="key"
                  dataSource={section.data}
                  columns={columns}
                  pagination={false}
                  showHeader={true}
                  size="small"
                  className="test-results-table"
                  style={{
                    backgroundColor: "#FAFAFA",
                  }}
                />
              </div>
            </Panel>
          ))}
          </Collapse>
        )}
      </div>
    </div>
  );
};

export default TestResults;

const getTagColor = (status) => {
  switch (status) {
    case "Safe":
    case "Standard":
      return "#5fcd28ff"; // Green for safe/standard
    case "UnSafe":
    case "Unsafe":
      return "#f21f23ff"; // Red for unsafe
    case "Sub-standard":
      return "#e09d17ff"; // Orange for sub-standard
    default:
      return "#8C8C8C"; // Gray for unknown status
  }
};
